import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

/** 로그인·회원가입·비밀번호 찾기 화면 공통 틀 */
const AuthCard = ({ title, subtitle, header, titleMb, children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
    }}
  >
    <Container component="main" maxWidth="sm">
      <Paper
        elevation={0}
        sx={{
          padding: 4,
          width: '115%',
          maxWidth: '575px',
          margin: '0 auto',
          bgcolor: 'background.default',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        {header}
        {title && (
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 'bold', color: 'text.primary', marginBottom: titleMb ?? (subtitle ? 1 : 4) }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.7 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Container>
  </Box>
);

export const authFieldSx = {
  mb: 2,
  '& .MuiOutlinedInput-root': { borderRadius: '4px' },
};

export const authLinkSx = {
  color: 'text.primary',
  textDecoration: 'none',
  cursor: 'pointer',
  fontSize: '0.875rem',
  '&:hover': { textDecoration: 'underline' },
};

export default AuthCard;
